// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  BulkInsertFoodData,
  BulkInsertFoodResponses,
  CalculateNeedData,
  CalculateNeedResponses,
  CompleteFoodData,
  CompleteFoodFromUrlData,
  CompleteFoodFromUrlResponses,
  CompleteFoodResponses,
  CompletePurchaseData,
  CompletePurchaseFromUrlData,
  CompletePurchaseFromUrlResponses,
  CompletePurchaseResponses,
  ConvertToDishData,
  ConvertToDishResponses,
  CreateDishData,
  CreateDishResponses,
  CreateFoodData,
  CreateFoodFromDishData,
  CreateFoodFromDishResponses,
  CreateFoodResponses,
  CreateFoodUnitData,
  CreateFoodUnitResponses,
  CreateIntakesFromEntityData,
  CreateIntakesFromEntityResponses,
  CreateMealFromEntityData,
  CreateMealFromEntityResponses,
  CreatePersonData,
  CreatePersonResponses,
  CreatePurchaseData,
  CreatePurchaseFromDishData,
  CreatePurchaseFromDishResponses,
  CreatePurchaseResponses,
  CreateShoppingListData,
  CreateShoppingListResponses,
  DefineNeedData,
  DefineNeedResponses,
  DeleteAvailabilityData,
  DeleteAvailabilityResponses,
  DeleteFoodData,
  DeleteFoodResponses,
  DeleteShoppingListData,
  DeleteShoppingListResponses,
  DishNutriData,
  DishNutriResponses,
  GetAllDepartmentsData,
  GetAllDepartmentsResponses,
  GetAllFoodsData,
  GetAllFoodsResponses,
  GetAllPersonsData,
  GetAllPersonsResponses,
  GetAllPurchasesData,
  GetAllPurchasesResponses,
  GetAllPurchaseUnitsData,
  GetAllPurchaseUnitsResponses,
  GetAllShopsData,
  GetAllShopsResponses,
  GetAvailabilitiesData,
  GetAvailabilitiesForFoodData,
  GetAvailabilitiesForFoodResponses,
  GetAvailabilitiesResponses,
  GetDishByFoodData,
  GetDishByFoodResponses,
  GetDishData,
  GetDishResponses,
  GetIngredientsData,
  GetIngredientsFromImageData,
  GetIngredientsFromImageResponses,
  GetIngredientsFromTextData,
  GetIngredientsFromTextResponses,
  GetIngredientsResponses,
  GetIntakesData,
  GetIntakesResponses,
  GetLastestIntakesData,
  GetLastestIntakesResponses,
  GetLastestMealsData,
  GetLastestMealsResponses,
  GetMaxNutriValuesData,
  GetMaxNutriValuesResponses,
  GetMealsData,
  GetMealsResponses,
  GetNeedsData,
  GetNeedsResponses,
  GetNetworkInfoData,
  GetNetworkInfoResponses,
  GetPersonDishesData,
  GetPersonDishesResponses,
  GetPersonsData,
  GetPersonsResponses,
  GetPurchaseData,
  GetPurchaseResponses,
  GetShoppingListData,
  GetShoppingListRequirementsData,
  GetShoppingListRequirementsResponses,
  GetShoppingListResponses,
  GetStocksData,
  GetStocksResponses,
  ImportFileData,
  ImportFileResponses,
  IntakeNutriData,
  IntakeNutriResponses,
  LoadAvailabilitiesByPurchasesData,
  LoadAvailabilitiesByPurchasesResponses,
  LoadAvailabilitiesData,
  LoadAvailabilitiesResponses,
  LoadFoodData,
  LoadFoodResponses,
  LoadFoodsByUnitsData,
  LoadFoodsByUnitsResponses,
  LoadFoodsData,
  LoadFoodsResponses,
  LoadPurchasesByFoodsData,
  LoadPurchasesByFoodsResponses,
  LoadPurchasesByUnitsData,
  LoadPurchasesByUnitsResponses,
  LoadPurchasesData,
  LoadPurchasesResponses,
  MealNutriData,
  MealNutriResponses,
  OrderReweData,
  OrderReweResponses,
  PlanData,
  PlanResponses,
  ReportErrorData,
  ReportErrorResponses,
  ResetData,
  ResetResponses,
  SaveAvailabilitiesData,
  SaveAvailabilitiesResponses,
  SavePlanData,
  SavePlanResponses,
  SaveShopsData,
  SaveShopsResponses,
  ScanData,
  ScanLabelData,
  ScanLabelResponses,
  ScanPurchaseLabelData,
  ScanPurchaseLabelResponses,
  ScanResponses,
  SearchDishData,
  SearchDishResponses,
  SearchFoodData,
  SearchFoodResponses,
  SearchMealSourceData,
  SearchMealSourceResponses,
  SearchPurchaseData,
  SearchPurchaseResponses,
  SuggestFoodData,
  SuggestFoodResponses,
  TestCreateDishData,
  TestCreateDishResponses,
  TestCreateFoodData,
  TestCreateFoodResponses,
  TestCreatePurchaseData,
  TestCreatePurchaseResponses,
  UpdateAvailabilitiesData,
  UpdateAvailabilitiesResponses,
  UpdateDefaultPurchaseFromDishData,
  UpdateDefaultPurchaseFromDishResponses,
  UpdateDishData,
  UpdateDishResponses,
  UpdateFoodData,
  UpdateFoodResponses,
  UpdateFoodUnitData,
  UpdateFoodUnitResponses,
  UpdateMealsData,
  UpdateMealsResponses,
  UpdateNeedsData,
  UpdateNeedsResponses,
  UpdatePersonData,
  UpdatePersonResponses,
  UpdatePurchaseData,
  UpdatePurchaseResponses,
  UpdateShoppingListsData,
  UpdateShoppingListsResponses,
  UpdateShopsData,
  UpdateShopsResponses,
  UpdateStocksData,
  UpdateStocksResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getStocks = (
  options?: Options<GetStocksData, true>,
): RequestResult<GetStocksResponses, unknown, true> =>
  (options?.client ?? client).get<GetStocksResponses, unknown, true>({
    url: "/api/stock",
    ...options,
    throwOnError: true,
  });

export const updateStocks = (
  options: Options<UpdateStocksData, true>,
): RequestResult<UpdateStocksResponses, unknown, true> =>
  (options.client ?? client).put<UpdateStocksResponses, unknown, true>({
    url: "/api/stock",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const deleteShoppingList = (
  options?: Options<DeleteShoppingListData, true>,
): RequestResult<DeleteShoppingListResponses, unknown, true> =>
  (options?.client ?? client).delete<
    DeleteShoppingListResponses,
    unknown,
    true
  >({ url: "/api/shopping-list", ...options, throwOnError: true });

export const getShoppingList = (
  options?: Options<GetShoppingListData, true>,
): RequestResult<GetShoppingListResponses, unknown, true> =>
  (options?.client ?? client).get<GetShoppingListResponses, unknown, true>({
    url: "/api/shopping-list",
    ...options,
    throwOnError: true,
  });

export const createShoppingList = (
  options: Options<CreateShoppingListData, true>,
): RequestResult<CreateShoppingListResponses, unknown, true> =>
  (options.client ?? client).post<CreateShoppingListResponses, unknown, true>({
    url: "/api/shopping-list",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateShoppingLists = (
  options: Options<UpdateShoppingListsData, true>,
): RequestResult<UpdateShoppingListsResponses, unknown, true> =>
  (options.client ?? client).put<UpdateShoppingListsResponses, unknown, true>({
    url: "/api/shopping-list",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getAllShops = (
  options?: Options<GetAllShopsData, true>,
): RequestResult<GetAllShopsResponses, unknown, true> =>
  (options?.client ?? client).get<GetAllShopsResponses, unknown, true>({
    url: "/api/shop",
    ...options,
    throwOnError: true,
  });

export const saveShops = (
  options: Options<SaveShopsData, true>,
): RequestResult<SaveShopsResponses, unknown, true> =>
  (options.client ?? client).post<SaveShopsResponses, unknown, true>({
    url: "/api/shop",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateShops = (
  options: Options<UpdateShopsData, true>,
): RequestResult<UpdateShopsResponses, unknown, true> =>
  (options.client ?? client).put<UpdateShopsResponses, unknown, true>({
    url: "/api/shop",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getAllPurchases = (
  options?: Options<GetAllPurchasesData, true>,
): RequestResult<GetAllPurchasesResponses, unknown, true> =>
  (options?.client ?? client).get<GetAllPurchasesResponses, unknown, true>({
    url: "/api/purchase",
    ...options,
    throwOnError: true,
  });

export const createPurchase = (
  options: Options<CreatePurchaseData, true>,
): RequestResult<CreatePurchaseResponses, unknown, true> =>
  (options.client ?? client).post<CreatePurchaseResponses, unknown, true>({
    url: "/api/purchase",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updatePurchase = (
  options: Options<UpdatePurchaseData, true>,
): RequestResult<UpdatePurchaseResponses, unknown, true> =>
  (options.client ?? client).put<UpdatePurchaseResponses, unknown, true>({
    url: "/api/purchase",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const createPurchaseFromDish = (
  options: Options<CreatePurchaseFromDishData, true>,
): RequestResult<CreatePurchaseFromDishResponses, unknown, true> =>
  (options.client ?? client).post<
    CreatePurchaseFromDishResponses,
    unknown,
    true
  >({
    url: "/api/purchase/fromDish",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateDefaultPurchaseFromDish = (
  options: Options<UpdateDefaultPurchaseFromDishData, true>,
): RequestResult<UpdateDefaultPurchaseFromDishResponses, unknown, true> =>
  (options.client ?? client).put<
    UpdateDefaultPurchaseFromDishResponses,
    unknown,
    true
  >({
    url: "/api/purchase/fromDish",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getAllPersons = (
  options?: Options<GetAllPersonsData, true>,
): RequestResult<GetAllPersonsResponses, unknown, true> =>
  (options?.client ?? client).get<GetAllPersonsResponses, unknown, true>({
    url: "/api/person",
    ...options,
    throwOnError: true,
  });

export const createPerson = (
  options: Options<CreatePersonData, true>,
): RequestResult<CreatePersonResponses, unknown, true> =>
  (options.client ?? client).post<CreatePersonResponses, unknown, true>({
    url: "/api/person",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updatePerson = (
  options: Options<UpdatePersonData, true>,
): RequestResult<UpdatePersonResponses, unknown, true> =>
  (options.client ?? client).put<UpdatePersonResponses, unknown, true>({
    url: "/api/person",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getNeeds = (
  options?: Options<GetNeedsData, true>,
): RequestResult<GetNeedsResponses, unknown, true> =>
  (options?.client ?? client).get<GetNeedsResponses, unknown, true>({
    url: "/api/need",
    ...options,
    throwOnError: true,
  });

export const defineNeed = (
  options: Options<DefineNeedData, true>,
): RequestResult<DefineNeedResponses, unknown, true> =>
  (options.client ?? client).post<DefineNeedResponses, unknown, true>({
    url: "/api/need",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateNeeds = (
  options: Options<UpdateNeedsData, true>,
): RequestResult<UpdateNeedsResponses, unknown, true> =>
  (options.client ?? client).put<UpdateNeedsResponses, unknown, true>({
    url: "/api/need",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getAllFoods = (
  options?: Options<GetAllFoodsData, true>,
): RequestResult<GetAllFoodsResponses, unknown, true> =>
  (options?.client ?? client).get<GetAllFoodsResponses, unknown, true>({
    url: "/api/food",
    ...options,
    throwOnError: true,
  });

export const createFood = (
  options: Options<CreateFoodData, true>,
): RequestResult<CreateFoodResponses, unknown, true> =>
  (options.client ?? client).post<CreateFoodResponses, unknown, true>({
    url: "/api/food",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateFood = (
  options: Options<UpdateFoodData, true>,
): RequestResult<UpdateFoodResponses, unknown, true> =>
  (options.client ?? client).put<UpdateFoodResponses, unknown, true>({
    url: "/api/food",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const createFoodUnit = (
  options: Options<CreateFoodUnitData, true>,
): RequestResult<CreateFoodUnitResponses, unknown, true> =>
  (options.client ?? client).post<CreateFoodUnitResponses, unknown, true>({
    url: "/api/foodUnit",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateFoodUnit = (
  options: Options<UpdateFoodUnitData, true>,
): RequestResult<UpdateFoodUnitResponses, unknown, true> =>
  (options.client ?? client).put<UpdateFoodUnitResponses, unknown, true>({
    url: "/api/foodUnit",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const createDish = (
  options: Options<CreateDishData, true>,
): RequestResult<CreateDishResponses, unknown, true> =>
  (options.client ?? client).post<CreateDishResponses, unknown, true>({
    url: "/api/dish",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateDish = (
  options: Options<UpdateDishData, true>,
): RequestResult<UpdateDishResponses, unknown, true> =>
  (options.client ?? client).put<UpdateDishResponses, unknown, true>({
    url: "/api/dish",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getAvailabilities = (
  options?: Options<GetAvailabilitiesData, true>,
): RequestResult<GetAvailabilitiesResponses, unknown, true> =>
  (options?.client ?? client).get<GetAvailabilitiesResponses, unknown, true>({
    url: "/api/availability",
    ...options,
    throwOnError: true,
  });

export const saveAvailabilities = (
  options: Options<SaveAvailabilitiesData, true>,
): RequestResult<SaveAvailabilitiesResponses, unknown, true> =>
  (options.client ?? client).post<SaveAvailabilitiesResponses, unknown, true>({
    url: "/api/availability",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateAvailabilities = (
  options: Options<UpdateAvailabilitiesData, true>,
): RequestResult<UpdateAvailabilitiesResponses, unknown, true> =>
  (options.client ?? client).put<UpdateAvailabilitiesResponses, unknown, true>({
    url: "/api/availability",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const updateMeals = (
  options: Options<UpdateMealsData, true>,
): RequestResult<UpdateMealsResponses, unknown, true> =>
  (options.client ?? client).post<UpdateMealsResponses, unknown, true>({
    url: "/api/updateMeals",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const reset = (
  options: Options<ResetData, true>,
): RequestResult<ResetResponses, unknown, true> =>
  (options.client ?? client).post<ResetResponses, unknown, true>({
    bodySerializer: null,
    url: "/api/test/reset",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "text/plain",
      ...options.headers,
    },
  });

export const testCreatePurchase = (
  options: Options<TestCreatePurchaseData, true>,
): RequestResult<TestCreatePurchaseResponses, unknown, true> =>
  (options.client ?? client).post<TestCreatePurchaseResponses, unknown, true>({
    url: "/api/test/purchase",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const plan = (
  options: Options<PlanData, true>,
): RequestResult<PlanResponses, unknown, true> =>
  (options.client ?? client).post<PlanResponses, unknown, true>({
    url: "/api/test/plan",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const mealNutri = (
  options: Options<MealNutriData, true>,
): RequestResult<MealNutriResponses, unknown, true> =>
  (options.client ?? client).post<MealNutriResponses, unknown, true>({
    url: "/api/test/meal-nutri",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const intakeNutri = (
  options: Options<IntakeNutriData, true>,
): RequestResult<IntakeNutriResponses, unknown, true> =>
  (options.client ?? client).post<IntakeNutriResponses, unknown, true>({
    url: "/api/test/intake-nutri",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const testCreateFood = (
  options: Options<TestCreateFoodData, true>,
): RequestResult<TestCreateFoodResponses, unknown, true> =>
  (options.client ?? client).post<TestCreateFoodResponses, unknown, true>({
    url: "/api/test/food",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const testCreateDish = (
  options: Options<TestCreateDishData, true>,
): RequestResult<TestCreateDishResponses, unknown, true> =>
  (options.client ?? client).post<TestCreateDishResponses, unknown, true>({
    url: "/api/test/dish",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const suggestFood = (
  options: Options<SuggestFoodData, true>,
): RequestResult<SuggestFoodResponses, unknown, true> =>
  (options.client ?? client).post<SuggestFoodResponses, unknown, true>({
    url: "/api/suggestFood",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const scan = (
  options?: Options<ScanData, true>,
): RequestResult<ScanResponses, unknown, true> =>
  (options?.client ?? client).post<ScanResponses, unknown, true>({
    ...formDataBodySerializer,
    url: "/api/scan",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

export const scanPurchaseLabel = (
  options?: Options<ScanPurchaseLabelData, true>,
): RequestResult<ScanPurchaseLabelResponses, unknown, true> =>
  (options?.client ?? client).post<ScanPurchaseLabelResponses, unknown, true>({
    ...formDataBodySerializer,
    url: "/api/scanPurchaseLabel",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

export const scanLabel = (
  options?: Options<ScanLabelData, true>,
): RequestResult<ScanLabelResponses, unknown, true> =>
  (options?.client ?? client).post<ScanLabelResponses, unknown, true>({
    ...formDataBodySerializer,
    url: "/api/scanLabel",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

export const loadPurchases = (
  options: Options<LoadPurchasesData, true>,
): RequestResult<LoadPurchasesResponses, unknown, true> =>
  (options.client ?? client).post<LoadPurchasesResponses, unknown, true>({
    url: "/api/purchases",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const loadPurchasesByUnits = (
  options: Options<LoadPurchasesByUnitsData, true>,
): RequestResult<LoadPurchasesByUnitsResponses, unknown, true> =>
  (options.client ?? client).post<LoadPurchasesByUnitsResponses, unknown, true>(
    {
      url: "/api/purchasesByUnits",
      ...options,
      throwOnError: true,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

export const loadPurchasesByFoods = (
  options: Options<LoadPurchasesByFoodsData, true>,
): RequestResult<LoadPurchasesByFoodsResponses, unknown, true> =>
  (options.client ?? client).post<LoadPurchasesByFoodsResponses, unknown, true>(
    {
      url: "/api/purchasesByFoods",
      ...options,
      throwOnError: true,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

export const searchPurchase = (
  options: Options<SearchPurchaseData, true>,
): RequestResult<SearchPurchaseResponses, unknown, true> =>
  (options.client ?? client).post<SearchPurchaseResponses, unknown, true>({
    url: "/api/purchase/search",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const savePlan = (
  options: Options<SavePlanData, true>,
): RequestResult<SavePlanResponses, unknown, true> =>
  (options.client ?? client).post<SavePlanResponses, unknown, true>({
    url: "/api/plan",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderRewe = (
  options?: Options<OrderReweData, true>,
): RequestResult<OrderReweResponses, unknown, true> =>
  (options?.client ?? client).post<OrderReweResponses, unknown, true>({
    url: "/api/orderRewe",
    ...options,
    throwOnError: true,
  });

export const searchMealSource = (
  options: Options<SearchMealSourceData, true>,
): RequestResult<SearchMealSourceResponses, unknown, true> =>
  (options.client ?? client).post<SearchMealSourceResponses, unknown, true>({
    url: "/api/mealsource/search",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const createMealFromEntity = (
  options: Options<CreateMealFromEntityData, true>,
): RequestResult<CreateMealFromEntityResponses, unknown, true> =>
  (options.client ?? client).post<CreateMealFromEntityResponses, unknown, true>(
    {
      url: "/api/mealFromEntity",
      ...options,
      throwOnError: true,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

export const createIntakesFromEntity = (
  options: Options<CreateIntakesFromEntityData, true>,
): RequestResult<CreateIntakesFromEntityResponses, unknown, true> =>
  (options.client ?? client).post<
    CreateIntakesFromEntityResponses,
    unknown,
    true
  >({
    url: "/api/intakeFromEntity",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getIngredients = (
  options: Options<GetIngredientsData, true>,
): RequestResult<GetIngredientsResponses, unknown, true> =>
  (options.client ?? client).post<GetIngredientsResponses, unknown, true>({
    url: "/api/ingredientsFromUrl",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getIngredientsFromText = (
  options: Options<GetIngredientsFromTextData, true>,
): RequestResult<GetIngredientsFromTextResponses, unknown, true> =>
  (options.client ?? client).post<
    GetIngredientsFromTextResponses,
    unknown,
    true
  >({
    url: "/api/ingredientsFromText",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getIngredientsFromImage = (
  options?: Options<GetIngredientsFromImageData, true>,
): RequestResult<GetIngredientsFromImageResponses, unknown, true> =>
  (options?.client ?? client).post<
    GetIngredientsFromImageResponses,
    unknown,
    true
  >({
    ...formDataBodySerializer,
    url: "/api/ingredientsFromImage",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

export const loadFoods = (
  options: Options<LoadFoodsData, true>,
): RequestResult<LoadFoodsResponses, unknown, true> =>
  (options.client ?? client).post<LoadFoodsResponses, unknown, true>({
    url: "/api/foods",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const loadFoodsByUnits = (
  options: Options<LoadFoodsByUnitsData, true>,
): RequestResult<LoadFoodsByUnitsResponses, unknown, true> =>
  (options.client ?? client).post<LoadFoodsByUnitsResponses, unknown, true>({
    url: "/api/foodsByUnits",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const searchFood = (
  options: Options<SearchFoodData, true>,
): RequestResult<SearchFoodResponses, unknown, true> =>
  (options.client ?? client).post<SearchFoodResponses, unknown, true>({
    url: "/api/food/search",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const createFoodFromDish = (
  options: Options<CreateFoodFromDishData, true>,
): RequestResult<CreateFoodFromDishResponses, unknown, true> =>
  (options.client ?? client).post<CreateFoodFromDishResponses, unknown, true>({
    url: "/api/food/fromDish",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const bulkInsertFood = (
  options: Options<BulkInsertFoodData, true>,
): RequestResult<BulkInsertFoodResponses, unknown, true> =>
  (options.client ?? client).post<BulkInsertFoodResponses, unknown, true>({
    url: "/api/food/bulk",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const importFile = (
  options?: Options<ImportFileData, true>,
): RequestResult<ImportFileResponses, unknown, true> =>
  (options?.client ?? client).post<ImportFileResponses, unknown, true>({
    ...formDataBodySerializer,
    url: "/api/excel/import",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

export const reportError = (
  options: Options<ReportErrorData, true>,
): RequestResult<ReportErrorResponses, unknown, true> =>
  (options.client ?? client).post<ReportErrorResponses, unknown, true>({
    url: "/api/error",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const searchDish = (
  options: Options<SearchDishData, true>,
): RequestResult<SearchDishResponses, unknown, true> =>
  (options.client ?? client).post<SearchDishResponses, unknown, true>({
    url: "/api/dish/search",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const convertToDish = (
  options: Options<ConvertToDishData, true>,
): RequestResult<ConvertToDishResponses, unknown, true> =>
  (options.client ?? client).post<ConvertToDishResponses, unknown, true>({
    url: "/api/convertToDish",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const completePurchase = (
  options: Options<CompletePurchaseData, true>,
): RequestResult<CompletePurchaseResponses, unknown, true> =>
  (options.client ?? client).post<CompletePurchaseResponses, unknown, true>({
    url: "/api/completePurchase",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const completePurchaseFromUrl = (
  options: Options<CompletePurchaseFromUrlData, true>,
): RequestResult<CompletePurchaseFromUrlResponses, unknown, true> =>
  (options.client ?? client).post<
    CompletePurchaseFromUrlResponses,
    unknown,
    true
  >({
    url: "/api/completePurchaseFromUrl",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const completeFood = (
  options: Options<CompleteFoodData, true>,
): RequestResult<CompleteFoodResponses, unknown, true> =>
  (options.client ?? client).post<CompleteFoodResponses, unknown, true>({
    url: "/api/completeFood",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const completeFoodFromUrl = (
  options: Options<CompleteFoodFromUrlData, true>,
): RequestResult<CompleteFoodFromUrlResponses, unknown, true> =>
  (options.client ?? client).post<CompleteFoodFromUrlResponses, unknown, true>({
    url: "/api/completeFoodFromUrl",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const calculateNeed = (
  options: Options<CalculateNeedData, true>,
): RequestResult<CalculateNeedResponses, unknown, true> =>
  (options.client ?? client).post<CalculateNeedResponses, unknown, true>({
    url: "/api/calculatedNeed",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const loadAvailabilities = (
  options: Options<LoadAvailabilitiesData, true>,
): RequestResult<LoadAvailabilitiesResponses, unknown, true> =>
  (options.client ?? client).post<LoadAvailabilitiesResponses, unknown, true>({
    url: "/api/availabilities",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const loadAvailabilitiesByPurchases = (
  options: Options<LoadAvailabilitiesByPurchasesData, true>,
): RequestResult<LoadAvailabilitiesByPurchasesResponses, unknown, true> =>
  (options.client ?? client).post<
    LoadAvailabilitiesByPurchasesResponses,
    unknown,
    true
  >({
    url: "/api/availabilitiesByPurchases",
    ...options,
    throwOnError: true,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getMaxNutriValues = (
  options: Options<GetMaxNutriValuesData, true>,
): RequestResult<GetMaxNutriValuesResponses, unknown, true> =>
  (options.client ?? client).get<GetMaxNutriValuesResponses, unknown, true>({
    url: "/api/{context}/max-nutri",
    ...options,
    throwOnError: true,
  });

export const getPersons = (
  options?: Options<GetPersonsData, true>,
): RequestResult<GetPersonsResponses, unknown, true> =>
  (options?.client ?? client).get<GetPersonsResponses, unknown, true>({
    url: "/api/test/persons",
    ...options,
    throwOnError: true,
  });

export const dishNutri = (
  options: Options<DishNutriData, true>,
): RequestResult<DishNutriResponses, unknown, true> =>
  (options.client ?? client).get<DishNutriResponses, unknown, true>({
    url: "/api/test/dish/{dishId}/nutri",
    ...options,
    throwOnError: true,
  });

export const getShoppingListRequirements = (
  options: Options<GetShoppingListRequirementsData, true>,
): RequestResult<GetShoppingListRequirementsResponses, unknown, true> =>
  (options.client ?? client).get<
    GetShoppingListRequirementsResponses,
    unknown,
    true
  >({ url: "/api/shopping-list-requirement", ...options, throwOnError: true });

export const getPurchase = (
  options: Options<GetPurchaseData, true>,
): RequestResult<GetPurchaseResponses, unknown, true> =>
  (options.client ?? client).get<GetPurchaseResponses, unknown, true>({
    url: "/api/purchase/{purchaseId}",
    ...options,
    throwOnError: true,
  });

export const getAllPurchaseUnits = (
  options?: Options<GetAllPurchaseUnitsData, true>,
): RequestResult<GetAllPurchaseUnitsResponses, unknown, true> =>
  (options?.client ?? client).get<GetAllPurchaseUnitsResponses, unknown, true>({
    url: "/api/purchase/all",
    ...options,
    throwOnError: true,
  });

export const getPersonDishes = (
  options?: Options<GetPersonDishesData, true>,
): RequestResult<GetPersonDishesResponses, unknown, true> =>
  (options?.client ?? client).get<GetPersonDishesResponses, unknown, true>({
    url: "/api/person-dish",
    ...options,
    throwOnError: true,
  });

export const getNetworkInfo = (
  options?: Options<GetNetworkInfoData, true>,
): RequestResult<GetNetworkInfoResponses, unknown, true> =>
  (options?.client ?? client).get<GetNetworkInfoResponses, unknown, true>({
    url: "/api/network/info",
    ...options,
    throwOnError: true,
  });

export const getLastestIntakes = (
  options: Options<GetLastestIntakesData, true>,
): RequestResult<GetLastestIntakesResponses, unknown, true> =>
  (options.client ?? client).get<GetLastestIntakesResponses, unknown, true>({
    url: "/api/mealsource/latestintakes",
    ...options,
    throwOnError: true,
  });

export const getLastestMeals = (
  options: Options<GetLastestMealsData, true>,
): RequestResult<GetLastestMealsResponses, unknown, true> =>
  (options.client ?? client).get<GetLastestMealsResponses, unknown, true>({
    url: "/api/mealsource/latest",
    ...options,
    throwOnError: true,
  });

export const getMeals = (
  options: Options<GetMealsData, true>,
): RequestResult<GetMealsResponses, unknown, true> =>
  (options.client ?? client).get<GetMealsResponses, unknown, true>({
    url: "/api/meals",
    ...options,
    throwOnError: true,
  });

export const getIntakes = (
  options: Options<GetIntakesData, true>,
): RequestResult<GetIntakesResponses, unknown, true> =>
  (options.client ?? client).get<GetIntakesResponses, unknown, true>({
    url: "/api/intakes",
    ...options,
    throwOnError: true,
  });

export const deleteFood = (
  options: Options<DeleteFoodData, true>,
): RequestResult<DeleteFoodResponses, unknown, true> =>
  (options.client ?? client).delete<DeleteFoodResponses, unknown, true>({
    url: "/api/food/{foodId}",
    ...options,
    throwOnError: true,
  });

export const loadFood = (
  options: Options<LoadFoodData, true>,
): RequestResult<LoadFoodResponses, unknown, true> =>
  (options.client ?? client).get<LoadFoodResponses, unknown, true>({
    url: "/api/food/{foodId}",
    ...options,
    throwOnError: true,
  });

export const getDish = (
  options: Options<GetDishData, true>,
): RequestResult<GetDishResponses, unknown, true> =>
  (options.client ?? client).get<GetDishResponses, unknown, true>({
    url: "/api/dish/{dishId}",
    ...options,
    throwOnError: true,
  });

export const getDishByFood = (
  options: Options<GetDishByFoodData, true>,
): RequestResult<GetDishByFoodResponses, unknown, true> =>
  (options.client ?? client).get<GetDishByFoodResponses, unknown, true>({
    url: "/api/dish/byFood/{foodId}",
    ...options,
    throwOnError: true,
  });

export const getAllDepartments = (
  options?: Options<GetAllDepartmentsData, true>,
): RequestResult<GetAllDepartmentsResponses, unknown, true> =>
  (options?.client ?? client).get<GetAllDepartmentsResponses, unknown, true>({
    url: "/api/department",
    ...options,
    throwOnError: true,
  });

export const getAvailabilitiesForFood = (
  options: Options<GetAvailabilitiesForFoodData, true>,
): RequestResult<GetAvailabilitiesForFoodResponses, unknown, true> =>
  (options.client ?? client).get<
    GetAvailabilitiesForFoodResponses,
    unknown,
    true
  >({ url: "/api/availability/food/{foodId}", ...options, throwOnError: true });

export const deleteAvailability = (
  options: Options<DeleteAvailabilityData, true>,
): RequestResult<DeleteAvailabilityResponses, unknown, true> =>
  (options.client ?? client).delete<DeleteAvailabilityResponses, unknown, true>(
    {
      url: "/api/availability/{availabilityId}",
      ...options,
      throwOnError: true,
    },
  );
